<template>
  <div class="purchase-steps">
    <steps-bar
      class="purchase-steps__wrap"
      :steps="purchase_steps"
      :active_id="active_id"
      :completed_ids="completed_ids"
      :enabled_ids="completed_ids"
      :allow_navigation="allow_navigation"
      :customizations="{ steps_alignment: 'column', symbol_size: '40px' }"
      outlined
      @select="go_to_step"
    />
  </div>
</template>

<script>
  import StepsBar from '@components/library/blocks/steps-bar.vue';

  /**
   * Rotta di ogni step del flusso.
   *
   * `confirm` non c'è di proposito: quella pagina vuole in rotta la coppia
   * confirm_code / gift_voucher_id dell'ordine, quindi non è un posto dove si
   * possa tornare da un click.
   */
  const STEP_ROUTES = {
    card: 'homepage',
    data: 'checkout',
  };

  export default {
    name: 'purchase-steps',

    components: {
      'steps-bar': StepsBar,
    },

    props: {
      // step corrente: è l'unica cosa che cambia fra le tre pagine del flusso
      active_id: {
        type: String,
        default: 'card',
      },
    },

    data() {
      return {
        purchase_steps: [
          { id: 'card', name: 'Scegli la Gift Card', icon: 'cart' },
          { id: 'data', name: 'Inserisci i tuoi dati', icon: 'clipboard' },
          { id: 'confirm', name: 'Conferma', icon: 'party-popper' },
        ],
      };
    },

    computed: {
      /**
       * Se dagli step si può navigare.
       *
       * Sulla conferma no: l'ordine è emesso ma prodotto e taglio sono ancora
       * nello store, quindi un ritorno al checkout darebbe un checkout
       * funzionante e si rischia una seconda gift card al posto di una rilettura.
       */
      allow_navigation() {
        return this.active_id !== 'confirm';
      },

      // gli step che precedono quello attivo restano accesi: pallino pieno, label
      // scura e lineetta di collegamento colorata. Sul primo step l'array è vuoto
      completed_ids() {
        const active_index = this.purchase_steps.findIndex((step) => step.id === this.active_id);
        if (active_index < 1) return [];
        return this.purchase_steps.slice(0, active_index).map((step) => step.id);
      },
    },

    methods: {
      // torna allo step cliccato: qui arrivano solo gli step precedenti
      // all'attivo, il resto lo scarta già steps-bar
      go_to_step(step_id) {
        const route_name = STEP_ROUTES[step_id];
        if (!route_name) return;

        this.$router.push({ name: route_name });
      },
    },
  };
</script>

<style lang="scss" scoped>

  .purchase-steps {
    &__wrap {
      padding: 0;
      background-color: transparent;
      border-radius: 0;
      max-width: 620px;
      margin: 0 auto;

      // gli step non ancora raggiunti si riconoscono dal pallino in outline:
      // non serve anche sbiadirli, come fa steps-bar di default
      ::v-deep .steps-bar__item--disabled {
        opacity: 1;
      }
    }
  }
</style>